module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "master-supplier-new"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/Stock"
    }
  }, [_vm._v(_vm._s(_vm.$t('Stock')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/master_stock"
    }
  }, [_vm._v(_vm._s(_vm.$t('Master Stock')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/master_supplier_list"
    }
  }, [_vm._v(_vm._s(_vm.$t('Master Supplier')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Master Supplier New')))])])]), _c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('Master Supplier New')))]), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v(_vm._s(_vm.$t('supplier.label.name')))]), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.name
    },
    attrs: {
      "type": "text",
      "placeholder": "サプライヤー名",
      "maxlength": "50"
    },
    domProps: {
      "value": _vm._s(_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.name),
      expression: "!validation.name"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v(_vm._s(_vm.$t('supplier.label.name_hurigana')))]), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name_hurigana),
      expression: "name_hurigana"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.name_hurigana
    },
    attrs: {
      "type": "text",
      "placeholder": "サプライヤー名ふりがな",
      "maxlength": "255"
    },
    domProps: {
      "value": _vm._s(_vm.name_hurigana)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name_hurigana = $event.target.value
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.name_hurigana),
      expression: "!validation.name_hurigana"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.invalid_furigana')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v(_vm._s(_vm.$t('supplier.label.responsible_name')))]), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.responsible_name),
      expression: "responsible_name"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.responsible_name
    },
    attrs: {
      "type": "text",
      "placeholder": "担当者名",
      "maxlength": "255"
    },
    domProps: {
      "value": _vm._s(_vm.responsible_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.responsible_name = $event.target.value
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.responsible_name),
      expression: "!validation.responsible_name"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v(_vm._s(_vm.$t('supplier.label.tel_no')))]), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tel_no),
      expression: "tel_no"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.tel_no
    },
    attrs: {
      "type": "text",
      "placeholder": "092-111-2222",
      "maxlength": "15"
    },
    domProps: {
      "value": _vm._s(_vm.tel_no)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tel_no = $event.target.value
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.tel_no),
      expression: "!validation.tel_no"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.fomat_tel')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v(_vm._s(_vm.$t('supplier.label.fax_no')))]), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fax_no),
      expression: "fax_no"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.fax_no
    },
    attrs: {
      "type": "text",
      "placeholder": "092-111-2222",
      "maxlength": "15"
    },
    domProps: {
      "value": _vm._s(_vm.fax_no)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fax_no = $event.target.value
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.fax_no),
      expression: "!validation.fax_no"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.fomat_tel')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v(_vm._s(_vm.$t('supplier.label.mail')))]), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mail),
      expression: "mail"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.mail
    },
    attrs: {
      "type": "text",
      "placeholder": "aaa@example.com",
      "maxlength": "255"
    },
    domProps: {
      "value": _vm._s(_vm.mail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mail = $event.target.value
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.mail),
      expression: "!validation.mail"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v(_vm._s(_vm.$t('supplier.label.postal_code')))]), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postal_code),
      expression: "postal_code"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.postal_code
    },
    attrs: {
      "type": "text",
      "placeholder": "111-2222",
      "maxlength": "8"
    },
    domProps: {
      "value": _vm._s(_vm.postal_code)
    },
    on: {
      "change": _vm.onChangePostNo,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.postal_code = $event.target.value
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.postal_code),
      expression: "!validation.postal_code"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v(_vm._s(_vm.$t('supplier.label.address')))]), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.address
    },
    attrs: {
      "type": "text",
      "placeholder": "福岡県福岡市博多区中洲1-1",
      "maxlength": "255"
    },
    domProps: {
      "value": _vm._s(_vm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.address),
      expression: "!validation.address"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v(_vm._s(_vm.$t('supplier.label.order_method')))]), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order_method),
      expression: "order_method"
    }],
    attrs: {
      "type": "radio",
      "value": "fax"
    },
    domProps: {
      "checked": _vm._q(_vm.order_method, "fax")
    },
    on: {
      "click": function($event) {
        _vm.order_method = "fax"
      }
    }
  }), _c('span', [_vm._v("FAX")])]), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order_method),
      expression: "order_method"
    }],
    attrs: {
      "type": "radio",
      "value": "email"
    },
    domProps: {
      "checked": _vm._q(_vm.order_method, "email")
    },
    on: {
      "click": function($event) {
        _vm.order_method = "email"
      }
    }
  }), _c('span', [_vm._v("e-mail")])]), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order_method),
      expression: "order_method"
    }],
    attrs: {
      "type": "radio",
      "value": "tanomail"
    },
    domProps: {
      "checked": _vm._q(_vm.order_method, "tanomail")
    },
    on: {
      "click": function($event) {
        _vm.order_method = "tanomail"
      }
    }
  }), _c('span', [_vm._v("たのめーる")])]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.order_method),
      expression: "!validation.order_method"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("発送手数料")]), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fee_type),
      expression: "fee_type"
    }],
    attrs: {
      "type": "radio",
      "value": "no_fee"
    },
    domProps: {
      "checked": _vm._q(_vm.fee_type, "no_fee")
    },
    on: {
      "click": function($event) {
        _vm.fee_type = "no_fee"
      }
    }
  }), _c('span', [_vm._v("手数料なし")])]), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fee_type),
      expression: "fee_type"
    }],
    attrs: {
      "type": "radio",
      "value": "zero_infinity"
    },
    domProps: {
      "checked": _vm._q(_vm.fee_type, "zero_infinity")
    },
    on: {
      "click": function($event) {
        _vm.fee_type = "zero_infinity"
      }
    }
  }), _c('span', [_vm._v("ゼロインフィニティ")])]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.fee_type),
      expression: "!validation.fee_type"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('a', {
    staticClass: "btn btn-info",
    class: {
      disabled: !_vm.validationAll
    },
    staticStyle: {
      "margin-right": "5px"
    },
    on: {
      "click": function($event) {
        _vm.onClickSave()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Save')))])]), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.onClickCancel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Cancel')))])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6f41048c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/master-supplier-new.pug
// module id = 846
// module chunks = 1